import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import { companySaga } from './saga';
import {
  CompanyState,
  ICompanyFormValues,
  ISetCompanyFormTypePayload,
  IEditCompanyPayload,
  ISetShareCompanyFormTypePayload,
  IGetCompanyByIdPayload,
  IShareCompanyPayload,
  ICompanyInList,
  IDeleteShareCompanyPayload,
  ICompanyDetails,
} from './types';

export const initialState: CompanyState = {
  companyList: {
    companiesArr: [],
    loading: false,
  },

  companyForm: {
    loading: false,
    isOpen: false,
    type: 'create',
    id: undefined,
  },
  shareCompanyForm: {
    deleteLoading: false,
    loading: false,
    isOpen: false,
    type: 'share',
    id: undefined,
    permissions: undefined,
  },

  companyDetails: {
    loading: false,
    company: null,
  },

  selectedCompanyId: null,
  selectedCompanyGroupId: null,
};

const slice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},

    getCompanies(state, action: PayloadAction<number>) {
      state.companyList.loading = true;
    },

    setCompanies(state, action: PayloadAction<ICompanyInList[]>) {
      state.companyList.companiesArr = action.payload;

      state.selectedCompanyId = null;
      state.selectedCompanyGroupId = null;
    },

    setCompaniesLoading(state, action: PayloadAction<boolean>) {
      state.companyList.loading = action.payload;
    },

    getCompanyById(state, action: PayloadAction<IGetCompanyByIdPayload>) {},

    setCompanyDetails(state, action: PayloadAction<ICompanyDetails>) {
      state.companyDetails.company = action.payload;
    },

    setCompanyDetailsLoading(state, action: PayloadAction<boolean>) {
      state.companyDetails.loading = action.payload;
    },

    createCompany(
      state,
      action: PayloadAction<{ envId: number; values: ICompanyFormValues }>,
    ) {},

    setCreateCompanyLoading(state, action: PayloadAction<boolean>) {
      state.companyForm.loading = action.payload;
    },

    editCompany(state, action: PayloadAction<IEditCompanyPayload>) {
      state.companyForm.loading = true;
    },

    // updateCompanyDetails(state, action: PayloadAction<ICompany>) {
    //   state.companyDetails.company = action.payload;
    // },

    toggleCompanyForm(state, action: PayloadAction<boolean>) {
      state.companyForm.isOpen = action.payload;
    },

    setCompanyFormType(
      state,
      action: PayloadAction<ISetCompanyFormTypePayload>,
    ) {
      state.companyForm.type = action.payload.type;
      state.companyForm.id = Number(action.payload.companyId);
    },

    toggleShareCompanyForm(state, action: PayloadAction<boolean>) {
      state.shareCompanyForm.isOpen = action.payload;
      // TODO: remove loader false
      if (!action.payload) {
        state.shareCompanyForm.loading = false;
      }
    },

    setShareCompanyFormType(
      state,
      action: PayloadAction<ISetShareCompanyFormTypePayload>,
    ) {
      state.shareCompanyForm.id = Number(action.payload.id);
      state.shareCompanyForm.type = action.payload.type;
      state.shareCompanyForm.permissions = action.payload.permissions;
    },
    deleteShareCompany(
      state,
      action: PayloadAction<IDeleteShareCompanyPayload>,
    ) {},
    setDeleteShareCompanyLoading(state, action: PayloadAction<boolean>) {
      state.shareCompanyForm.deleteLoading = action.payload;
    },
    shareCompany(state, action: PayloadAction<IShareCompanyPayload>) {},
    setShareCompanyLoading(state, action: PayloadAction<boolean>) {
      state.shareCompanyForm.loading = action.payload;
    },

    setSelectedCompanyId(state, action: PayloadAction<number | null>) {
      state.selectedCompanyId = action.payload || null;
      state.selectedCompanyGroupId = null;
    },

    setSelectedCompanyGroupId(state, action: PayloadAction<number | null>) {
      state.selectedCompanyId = null;
      state.selectedCompanyGroupId = action.payload || null;
    },
  },
});

export const { actions: companyActions } = slice;

export const useCompanySlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: companySaga });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useCompanySlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
